<template>
    <div class="home-box">
      <PageTitle :title="'Create New User'" class="py-5"></PageTitle>
      <v-row align="center">
        <v-overlay :value="loading" :opacity="1" :color="'#FFFFFF'">
          <v-progress-circular color="blue" indeterminate size="64"></v-progress-circular>
        </v-overlay>
  
        <div class="col-md-12 home-tabs-body">
          <EmployerCreateForm></EmployerCreateForm>
        </div>
      </v-row>
    </div>
  </template>
  
  <script>
  import EmployerCreateForm from "@/components/employers/CreateForm";
  import PageTitle from "@/components/shared/PageTitle";
  import { createNamespacedHelpers } from "vuex";
  const { mapGetters } = createNamespacedHelpers("auth");
  
  export default {
    name: "EmployerCreate",
    components: {
      EmployerCreateForm,
      PageTitle,
    },
    data: function () {
      return {
        editMode: false,
        loading: false
      };
    },
    computed: {
      ...mapGetters({
        profile: "profile",
      }),
    },
    mounted() {
      this.$store.dispatch("auth/getProfile");
      this.$store.dispatch("settings/getCompanySettings");
    },
  
    watch: {
    }
  };
  </script>